import React from 'react';

type UseLockScroll = {
  lockScroll: () => void;
  unlockScroll: () => void;
};

const useScrollLock = (): UseLockScroll => {
  const lockScroll = React.useCallback(() => {
    document.body.style.overflow = 'hidden';
  }, []);

  const unlockScroll = React.useCallback(() => {
    document.body.style.overflow = '';
  }, []);

  return {
    lockScroll,
    unlockScroll,
  };
};

export default useScrollLock;
